jQuery(function ($) {
  var singlePage;

  var $formatDate = function (date) {
    var $dateAndTime = date.split('T');
    var $date = $dateAndTime[0].split('-').reverse().join('.');
    var $time = $dateAndTime[1].split(':');
    var $dateArr = [$date, $time];
    return $dateArr;
  };

  $.SinglePage = function () {
  };

  $.SinglePage.prototype = {

    comment_page: 2,
    init: function () {
      this.stickySidebarBox();
      this.click_events();
      this.initializeFancyBox();
      this.copyToClipboard();
    },

    stickySidebarBox: function () {
      var barHeight = $('.site-header').outerHeight();
      var detailbox = $('.detailbox');
      var siteHeader = $('.site-header');
      var toTop = $('.to-top');
      var sidebarAd = ($('.sidebar-ad').length > 0) ? $('.sidebar-ad') : null;
      var promo = ($('.post-content-promotion').length > 0) ? $('.post-content-promotion') : null;
      var promoHeight = ($('.post-content-promotion').length > 0) ? promo.innerHeight() : 0;
      var position;
      var stopAt = barHeight;
      var diff = 0;
      var underAd = 0;
      var onScreen = 0;
      var ad = false;
      var ws = $(window).scrollTop();
      var isTop = true;

      if (promo && promoHeight > 20) {
        detailbox.addClass('no-transform');
      }

      $(window).on('scroll', function () {
        ws = $(window).scrollTop();

        if ($('.sidebar-ad').length > 0 && $('.sidebar-ad').innerHeight() > 0 && ad === false) {
          ad = true;
          sidebarAd = $('.sidebar-ad');
          detailbox.removeClass('no-ad');
        }

        if (ad === true) {
          underAd = Math.round(sidebarAd.offset().top + sidebarAd.innerHeight()) - siteHeader.innerHeight() - 50 - promoHeight;
          onScreen = $(window).scrollTop() + $(window).innerHeight() - siteHeader.innerHeight();
          diff = (underAd) - ($(window).scrollTop() - siteHeader.innerHeight());

          if ($(window).width() >= 992) {
            if (ws > 200 + promoHeight && isTop === true) {
              isTop = false;
              detailbox.addClass('faded');
            } else if (ws > 500 + promoHeight && ws < 600 + promoHeight && isTop === false) {
              detailbox.addClass('faded');
            } else if (ws > 600 + promoHeight && isTop === false) {
              isTop = false;
              detailbox.removeClass('faded');
            } else if (ws < 200 + promoHeight) {
              isTop = true;
              detailbox.removeClass('faded');
            }

            if (diff + promoHeight < 78) {
              if (typeof $.uniqBase !== 'undefined' && typeof $.uniqBase.StickySidebar !== 'undefined') {
                detailbox.uniqBase_stickySidebar({
                  setStickyAt: '.site-header',
                  wrapperContainer: '.post-content-row',
                  offsetTop: ((promo && promoHeight > 20) ? 20 : 20),
                  beforeInit: function (base) {
                    base.stopAt = base.$el.height() + base.stickyAt + base.options.offsetTop + ((promo && promoHeight > 20) ? 36 : 0);
                  },
                  stopAtBottom: function (base) {
                    base.$el.css({
                      position: 'relative',
                      top: $(base.wrapperContainer).height() - base.$el.height() - 78,
                      width: base.stickyWidth
                    });
                  }
                });
              }
            } else if (onScreen > underAd && ws >= 500 + promoHeight) {
              detailbox.css({ top: (underAd) + 'px', position: 'absolute' });
            } else if (ws < (detailbox.offset().top + detailbox.innerHeight() - siteHeader.innerHeight() + promoHeight)) {
              detailbox.removeAttr('style');
            }
          }
        }
      });

      if (ad === false && $(window).width() >= 992 && diff <= 0) {
        detailbox.addClass('no-ad');
        if (typeof $.uniqBase !== 'undefined' && typeof $.uniqBase.StickySidebar !== 'undefined') {
          detailbox.uniqBase_stickySidebar({
            setStickyAt: '.site-header',
            wrapperContainer: '.post-content-row',
            offsetTop: ((promo && promoHeight > 20) ? -30 : 20),
            beforeInit: function (base) {
              base.stopAt = base.$el.height() + base.stickyAt + base.options.offsetTop + ((promo && promoHeight > 20) ? 36 : -50);
            },
            stopAtBottom: function (base) {
              base.$el.css({
                position: 'relative',
                top: $(base.wrapperContainer).height() - base.$el.height() + ((promo && promoHeight > 20) ? -38 : 12),
                width: base.stickyWidth
              });
            }
          });
        }
      }

      if (ad === false && $(window).width() < 992) {
        if ($('.post-comments')) {
          stopAt = $('.post-comments').innerHeight();
        }

        $('.deal-btn-wrapper').uniqBase_stickySidebar({
          setStickyAt: '.site-header',
          wrapperContainer: '.post-content',

          beforeInit: function (base) {
            if (base.$el.hasClass('sold-out-opacity')) {
              return;
            }

            position = base.$el.position();
            base.stickyAt = (position.top + base.$el.outerHeight()) * (-1) + barHeight;
            base.stopAt = stopAt;

            base.clonedContainer = base.$el.clone();
            base.clonedContainer.addClass('clonedElement transition');
            $('body').append(base.clonedContainer);
          },
          scrollBottomUp: function (base) {
            if (base.clonedContainer) {
              base.clonedContainer.addClass('fixed');
              toTop.addClass('deals-on');
            }
          },
          stopAtBottom: function (base) {
            if (base.clonedContainer) {
              base.clonedContainer.removeClass('fixed');
              toTop.removeClass('deals-on');
            }
          },
          initialPosition: function (base) {
            if (base.clonedContainer) {
              base.clonedContainer.removeClass('fixed');
              toTop.removeClass('deals-on');
            }
          },
          setSticky: function (base) {
            if (base.clonedContainer) {
              base.clonedContainer.addClass('fixed');
              toTop.addClass('deals-on');
            }
          }
        });
      }
    },
    // Step Wizard
    click_events: function () {
      var parent = this;

      $('body').on('click', '.btn-reply', function (e) {
        e.preventDefault();
        $(this).next().toggleClass('show');
      });

      // load more comments
      $('#load-more-comments').on('click', function (e) {
        var $this = $(this);
        e.preventDefault();

        $.ajax({
          type: 'GET',
          url: ajax_url,
          data: {
            action: 'load_more_comments',
            post_id: post_id,
            page: parent.comment_page
          },
          contentType: 'application/json; charset=utf-8',
          dataType: 'json',
          success: function (data) {
            $.each(data.items, function (i, item) {
              var $comment = $($('.dummy-comment').html());
              var $commentChild;
              var $date = $formatDate(item.createDate)[0];
              var $time = $formatDate(item.createDate)[1];

              $comment.find('.reply-form .btn-reply').attr('data-target', '#reply-' + item.id);
              $comment.find('.reply-form-container').attr('id', 'reply-' + item.id);
              $comment.find('.reply-form-container input[name=comment_parent]').val(item.id);
              $comment.find('.panel-comment').attr('id', 'comment-' + item.id);
              $comment.find('.panel-comment .author-name').text(item.author);
              $comment.find('.date-label').html($date);
              $comment.find('.time-label').html($time[0] + ':' + $time[1]);
              $comment.find('.comment-text').html('<p>' + item.content.replace('\n', '<br />', 'g') + '</p>');

              // Render Child Comments
              if (item.childComments) {
                $.each(item.childComments.reverse(), function (ii, iitem) {
                  $date = $formatDate(iitem.createDate)[0];
                  $time = $formatDate(iitem.createDate)[1];
                  $commentChild = $($('.dummy-comment-child').html());
                  $commentChild.find('.author-name').text(iitem.author);
                  $commentChild.find('.date-label').html($date);
                  $commentChild.find('.time-label').html($time[0] + ':' + $time[1]);
                  $commentChild.find('.comment-text').html('<p>' + iitem.content.replace('\n', '<br />', 'g') + '</p>');
                  $commentChild.insertBefore($comment.find('.reply-form'));
                });
              }

              $('.comments-list').append($comment);
              $('.comments-list').append('<div class="panel-line"></div>');
            });

            if (data.total_items <= (data.items_per_page * (parent.comment_page))) {
              $this.remove();
            }
            parent.comment_page += 1;
          }
        });
      });
    },

    copyToClipboard: function () {
      if (typeof $.uniqBase !== 'undefined' && typeof $.uniqBase.copyToClipboard !== 'undefined') {
        $('.coupon-code-box').each(function () {
          $(this).uniqBase_copyToClipboard({
            defaultButton: '<i class="far fa-copy" aria-hidden="true"></i>',
            buttonSelected: '<i class="far fa-check-square" aria-hidden="true"></i>',
            analyticsCallback: function () {
              if (typeof ga === 'function') {
                ga('send', 'event', 'Voucher', 'copied', 'Gutscheincode');
              }
            }
          });
        });
      }
    },

    initializeFancyBox: function () {
      $('.lightbox-gallery').uniqBase_fancyBoxWrapper({
        groupName: 'gallery'
      });
    }
  };

  singlePage = new $.SinglePage();
  singlePage.init();
});
